import React from 'react'
import { Link } from 'react-router-dom'

export default function MetricCard({ title, value, yoyChange, linkTo, subtitle, changeLabel = 'YoY', absoluteChange }) {
  // Parse yoyChange to ensure it's a number (API might return string)
  const parsedChange = parseFloat(yoyChange)
  const change = !isNaN(parsedChange) ? parsedChange : 0
  const isPositive = change >= 0
  const changeColor = isPositive ? 'text-green-600' : 'text-red-600'
  const changeSymbol = isPositive ? '+' : ''

  // Parse absoluteChange if provided
  const parsedAbsoluteChange = absoluteChange !== undefined ? parseFloat(absoluteChange) : null
  const absChange = parsedAbsoluteChange !== null && !isNaN(parsedAbsoluteChange) ? parsedAbsoluteChange : null
  const absChangeSymbol = absChange !== null && absChange >= 0 ? '+' : ''

  return (
    <Link
      to={linkTo}
      className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow duration-200 cursor-pointer"
    >
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-1">
            <dt className="text-sm font-medium text-gray-500 truncate">
              {title}
            </dt>
            <dd className="mt-1 text-3xl font-semibold text-gray-900">
              {value}
            </dd>
            {subtitle ? (
              <dd className="mt-1 text-sm text-green-600 flex items-center">
                {subtitle}
              </dd>
            ) : absChange !== null ? (
              <dd className={`mt-1 text-sm ${changeColor} flex items-center`}>
                {absChangeSymbol}{absChange} / {changeSymbol}{change.toFixed(1)}% {changeLabel}
              </dd>
            ) : (
              <dd className={`mt-1 text-sm ${changeColor} flex items-center`}>
                {changeSymbol}{change.toFixed(1)}% {changeLabel}
              </dd>
            )}
          </div>
        </div>
      </div>
    </Link>
  )
}
